import * as React from 'react';
import { Article } from 'constants/blog';
import { BLOG_PAGE } from 'constants/pages';
import { ButtonLink } from 'components/Button';
import Link from 'components/Link';
import Post from 'components/blog/Post';

interface Props {
  sectionAnchor: string;
  data: any;
}

export default function LatestPosts({ sectionAnchor, data }: Props) {
  return (
    <div id={sectionAnchor} className="relative accent-brand-gray-25">
      <div className="px-gutter-base py-14 md:py-20">
        <div className="mx-auto max-w-[1200px]">
          <h2 className="text-center font-family-poppins text-3xl font-bold leading-relaxed text-color-text-lightmode-primary dark:text-color-text-darkmode-primary md:leading-[96px]">
            Latest blog posts
          </h2>
          <p className="text-center text-base text-color-text-lightmode-primary dark:text-color-text-darkmode-primary md:text-2xl">
            Choose from an array of topics in the world of tennis and pickleball.
          </p>
          <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {data.map((post: Article, index: number) => {
              return (
                <Post
                  key={index}
                  tags={post.categories?.map(({ label }) => label)}
                  title={post.title}
                  createdAt={post.publishedAt}
                  author={post.author}
                  previewText={post.previewDescription}
                  image={post?.mainImage}
                  slug={post.slug}
                  id={post._id}
                />
              );
            })}
          </div>
          <div className="mt-12 flex w-full justify-center">
            <ButtonLink href={BLOG_PAGE} variant="primary" isInline size="lg">
              View all
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  );
}
